// extracted by mini-css-extract-plugin
module.exports = {"pageSections":"_7b77h"};